;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('PreferencesService', PreferencesService)

  PreferencesService.$inject = [
    // Angular
    '$q', '$rootScope',

    // Managers
    'ParamsManager',
    'ProductParamsManager',
    'OrderParamsManager',
    'CompanyParamsManager',
    'InvoiceParamsManager',
    'QuoteParamsManager',
    'CreditNoteParamsManager',
    'UserManager',

    // Services
    'SessionService'

  ]

  /**
   * @ngdoc service
   * @name PreferencesService
   */
  function PreferencesService (
    // Angular
    $q, $rootScope,

    // Managers
    ParamsManager,
    ProductParamsManager,
    OrderParamsManager,
    CompanyParamsManager,
    InvoiceParamsManager,
    QuoteParamsManager,
    CreditNoteParamsManager,
    UserManager,

    // Services
    SessionService

  ) {
    var self = this

    var allUnits = [
      {
        group: 'Taille',
        label: 'Mètre',
        abbrevation: 'm'
      },
      {
        group: 'Taille',
        label: 'Mètre Linéaire',
        abbrevation: 'ml'
      },

      {
        group: 'Surface',
        label: 'Millimètre carré',
        abbrevation: 'mm2'
      },
      {
        group: 'Surface',
        label: 'Centimètre carré',
        abbrevation: 'cm2'
      },
      {
        group: 'Surface',
        label: 'Mètre carré',
        abbrevation: 'm2'
      },

      {
        group: 'Temps',
        label: 'Heure',
        abbrevation: 'Heure'
      },
      {
        group: 'Temps',
        label: 'Jour',
        abbrevation: 'Jour'
      },
      {
        group: 'Temps',
        label: 'Mois',
        abbrevation: 'Mois'
      },
      {
        group: 'Temps',
        label: 'Année',
        abbrevation: 'Année'
      },

      {
        group: 'Prestation',
        label: 'Forfait',
        abbrevation: 'Forfait'
      },

      {
        group: 'Autre',
        label: 'Article',
        abbrevation: 'Article'
      },
      {
        group: 'Autre',
        label: 'Remise',
        abbrevation: 'Remise'
      }
    ]

    var defaultColumns = {
      invoice: [
        { id: 'number', label: 'Numéro', visible: true, sortable: true },
        { id: 'reference', label: 'Référence client', visible: true, sortable: true },
        { id: 'creditnotes', label: 'Avoirs', visible: true, sortable: false },
        { id: 'title', label: 'Intitulé', visible: false, sortable: true },
        { id: 'client', label: 'Client', visible: true, sortable: true },
        { id: 'date', label: 'Émission', visible: true, sortable: true },
        { id: 'dueDate', label: 'Échéance', visible: true, sortable: true },
        { id: 'status', label: 'État', visible: true, sortable: true },
        { id: 'tags', label: 'Mots-clés', visible: true, sortable: false },
        { id: 'referers', label: 'Référents', visible: true, sortable: false },
        { id: 'computed.fullDiscountedTotal', label: 'Total HT', visible: false, sortable: true },
        { id: 'computed.discount', label: 'Remise', visible: false, sortable: true },
        { id: 'totalVAT', label: 'TVA', visible: false, sortable: true },
        { id: 'balanceDue', label: 'Balance', visible: true, sortable: true },
        { id: 'balancePaid', label: 'Perçu', visible: false, sortable: false },
        { id: 'fullTotal', label: 'TTC', visible: true, sortable: false }
      ],
      order: [
        { id: 'number', label: 'Numéro', visible: true, sortable: true },
        { id: 'reference', label: 'Référence client', visible: true, sortable: true },
        { id: 'title', label: 'Intitulé', visible: false, sortable: true },
        { id: 'client', label: 'Client', visible: true, sortable: true },
        { id: 'date', label: 'Émission', visible: true, sortable: true },
        { id: 'dueDate', label: 'Échéance', visible: true, sortable: true },
        { id: 'status', label: 'État', visible: true, sortable: true },
        { id: 'tags', label: 'Mots-clés', visible: true, sortable: false },
        { id: 'referers', label: 'Référents', visible: true, sortable: false },
        { id: 'total', label: 'Total HT', visible: false, sortable: true },
        { id: 'discountedTotal', label: 'Total Remisé', visible: false, sortable: false },
        { id: 'totalVAT', label: 'TVA', visible: false, sortable: true },
        { id: 'balanceDue', label: 'Balance', visible: true, sortable: true },
        { id: 'balancePaid', label: 'Perçu', visible: false, sortable: false },
        { id: 'fullTotal', label: 'TTC', visible: true, sortable: false }
      ],
      quote: [
        { id: 'number', label: 'Numéro', visible: true, sortable: true },
        { id: 'reference', label: 'Référence client', visible: true, sortable: true },
        { id: 'title', label: 'Intitulé', visible: false, sortable: true },
        { id: 'client', label: 'Client', visible: true, sortable: true },
        { id: 'date', label: 'Émission', visible: true, sortable: true },
        { id: 'dueDate', label: 'Échéance', visible: true, sortable: true },
        { id: 'signDate', label: 'Signature', visible: true, sortable: true },
        { id: 'status', label: 'État', visible: true, sortable: true },
        { id: 'tags', label: 'Mots-clés', visible: true, sortable: false },
        { id: 'referers', label: 'Référents', visible: true, sortable: false },
        { id: 'computed.fullDiscountedTotal', label: 'Total HT', visible: true, sortable: true },
        { id: 'computed.discount', label: 'Remise', visible: false, sortable: true },
        { id: 'fullTotal', label: 'Total TTC', visible: true, sortable: true },
        { id: 'totalVAT', label: 'TVA', visible: false, sortable: true }
      ],
      creditnote: [
        { id: 'number', label: 'Numéro', visible: true, sortable: true },
        { id: 'reference', label: 'Référence client', visible: true, sortable: true },
        { id: 'title', label: 'Intitulé', visible: false, sortable: true },
        { id: 'client', label: 'Client', visible: true, sortable: false },
        { id: 'date', label: 'Émission', visible: true, sortable: true },
        { id: 'dueDate', label: 'Échéance', visible: true, sortable: true },
        { id: 'status', label: 'État', visible: true, sortable: true },
        { id: 'tags', label: 'Mots-clés', visible: true, sortable: false },
        { id: 'referers', label: 'Référents', visible: true, sortable: false },
        { id: 'total', label: 'Total HT', visible: false, sortable: true },
        { id: 'totalVAT', label: 'TVA', visible: false, sortable: true },
        { id: 'balanceDue', label: 'Balance', visible: true, sortable: true },
        { id: 'balancePaid', label: 'Perçu', visible: false, sortable: false },
        { id: 'fullTotal', label: 'TTC', visible: true, sortable: false }
      ],
      product: [
        { id: 'reference', label: 'Référence', visible: true, sortable: true },
        { id: 'label', label: 'Désignation', visible: true, sortable: true },
        { id: 'category', label: 'Catégorie', visible: true, sortable: true },
        { id: 'tags', label: 'Mots-clés', visible: true, sortable: false },
        { id: 'price', label: 'Prix', visible: true, sortable: true },
        { id: 'unit', label: 'Unité', visible: false, sortable: true },
        { id: 'VAT', label: 'TVA', visible: true, sortable: true },
        { id: 'type', label: 'Type', visible: true, sortable: false }
      ],
      entity: [
        { id: 'insensitive', label: 'Nom', visible: true, sortable: true },
        { id: 'number', label: 'N° client', visible: true, sortable: true },
        { id: 'account', label: 'Compte client', visible: true, sortable: true },
        { id: 'defaultAddress', label: 'Adresse', visible: true, sortable: true },
        { id: 'balance', label: 'Balance', visible: true, sortable: false },
        { id: 'invoices', label: 'Factures', visible: true, sortable: false },
        { id: 'quotes', label: 'Devis', visible: true, sortable: false },
        { id: 'creditnotes', label: 'Avoirs', visible: true, sortable: false }
      ],
      inmail: [
        { id: 'raw.title', label: 'Titre', visible: true, sortable: true },
        { id: 'metadata.receivedAt', label: 'Date de réception', visible: true, sortable: true }
      ],
      bpu: [
        { id: 'label', label: 'Nom', visible: true, sortable: true },
        { id: 'client', label: 'Client', visible: true, sortable: true },
        { id: 'start', label: 'Date de début', visible: true, sortable: true },
        { id: 'end', label: 'Date de fin', visible: true, sortable: true }
      ]
    }

    var defaultParams = {
      settings: {
        sideBarVisible: false,
        invoiceList: {
          columns: defaultColumns['invoice'],
          pagination: 10
        },
        quoteList: {
          columns: defaultColumns['quote'],
          pagination: 10
        },
        creditnoteList: {
          columns: defaultColumns['creditnote'],
          pagination: 10
        },
        orderList: {
          columns: defaultColumns['order'],
          pagination: 10
        },
        productList: {
          columns: defaultColumns['product'],
          pagination: 10
        },
        entityList: {
          columns: defaultColumns['entity'],
          pagination: 10
        },
        inboxList: {
          columns: defaultColumns['inmail'],
          pagination: 10
        },
        bpuList: {
          columns: defaultColumns['bpu'],
          pagination: 10
        },
        dashboard: {
          default: null
        },
        edition: {
          displayActivity: false
        }
      }
    }

    var companyDefaults = {
      defaultUnit: {
        group: 'Autre',
        label: 'Article',
        abbrevation: 'Article'
      },

      units: [
        {
          group: 'Taille',
          label: 'Mètre',
          abbrevation: 'm'
        },
        {
          group: 'Autre',
          label: 'Article',
          abbrevation: 'Article'
        },
        {
          group: 'Surface',
          label: 'Mètre carré',
          abbrevation: 'm2'
        },
        {
          group: 'Temps',
          label: 'Heure',
          abbrevation: 'Heure'
        }
      ],

      vats: [0, 5.5, 7, 10, 20],
      enabledFeatures: {
        pdfWithInterventions: true
      }
    }

    var invoiceDefaults = {
      numberFormat: '$t(YYYY)_$n(4)',

      periodicity: 'year',

      invoiceDelay: 45,

      defaultConditions: '',

      defaultThanks: ''
    }

    var quoteDefaults = {
      numberFormat: '$t(YYYY)_$n(4)',

      periodicity: 'year',

      quoteDelay: 45,

      defaultConditions: '',

      defaultThanks: ''
    }

    var creditNoteDefaults = {
      numberFormat: '$t(YYYY)_$n(4)',

      periodicity: 'year',

      creditNoteDelay: 45,

      defaultConditions: '',

      defaultThanks: ''
    }

    var orderDefaults = {
      numberFormat: '$t(YYYY)_$n(4)',

      periodicity: 'year',

      orderDelay: 45,

      defaultConditions: '',

      defaultThanks: ''
    }

    var productDefaults = {
      redirect: 'new'
    }

    $rootScope.$on('refreshCompanyPrefs', function () {
      refreshCompanyPrefs()
    })

    function init () {
      return UserManager.getProfile().then(function (profile) {
        var cie = SessionService.getCompany()
        var currentCompany = _.find(_.get(profile, 'companies'), { _id: cie })
        companyDefaults.companyInfo = currentCompany.masterchief
        delete companyDefaults.companyInfo?._id
        refreshCompanyPrefs()
      })
    }

    function refreshCompanyPrefs () {
      getCompanyPrefs().then(function (prefs) {
        $rootScope.$broadcast('subcontractorOptions', _.get(prefs, 'enabledFeatures.subcontracts', false))
        if (!_.has(prefs, 'enabledFeatures')) {
          prefs.enabledFeatures = {
            pdfWithInterventions: false
          }
        }
        self.companyPrefs = prefs
        getGeneralPrefs().then(function (preferences) {
          if (preferences.settings.noFilters) {
            preferences.settings.invoiceList.search = {}
            preferences.settings.quoteList.search = {}
            preferences.settings.creditnoteList.search = {}
            preferences.save()
          }
        })
      })
    }

    function isCompanyPrefsValid () {
      if (!self.companyPrefs) return true
      return (
        _.get(self.companyPrefs, 'companyInfo.name') &&
        _.get(self.companyPrefs, 'companyInfo.phone') &&
        _.get(self.companyPrefs, 'companyInfo.email') &&
        _.get(self.companyPrefs, 'companyInfo.siret') &&
        _.get(self.companyPrefs, 'companyInfo.apeCode') &&
        _.get(self.companyPrefs, 'companyInfo.rcs') &&
        _.get(self.companyPrefs, 'companyInfo.address.addressLine1') &&
        _.get(self.companyPrefs, 'companyInfo.address.postalCode') &&
        _.get(self.companyPrefs, 'companyInfo.address.city') &&
        _.get(self.companyPrefs, 'companyInfo.address.country')
      )
    }

    self.initialization = init()

    function getInvoicePrefs () {
      if (!self.preferences) {
        self.preferences = InvoiceParamsManager.get().then(function (data) {
          if (!data.data.length) {
            return InvoiceParamsManager.create(invoiceDefaults).save().then(function (data) {
              return data
            })
          } else {
            return data.data[0]
          }
        })
      }
      return self.preferences
    }

    function getGeneralPrefs () {
      if (!self.generalPreferences) {
        var paramsQuery =
        ParamsManager
          .query()
          .select(SessionService.getUser(), 'user')
          .select(SessionService.getCompany(), 'company')
        self.generalPreferences = ParamsManager.get(paramsQuery).then(function (data) {
          if (!data.data.length) {
            return ParamsManager.create(defaultParams).save().then(function () {
              return ParamsManager.get(paramsQuery).then(function (data) {
                return data.data[0]
              })
            })
          } else {
            return data.data[0]
          }
        })
      }
      return self.generalPreferences
    }

    function getCompanyPrefs () {
      if (!self.companyPreferences) {
        const companyParamsQuery = CompanyParamsManager.query().select(SessionService.getCompany(), 'company')
        self.companyPreferences = CompanyParamsManager.get(companyParamsQuery).then(function (data) {
          if (!data.data.length) {
            return self.initialization.then(function () {
              return CompanyParamsManager.create(companyDefaults).save().then(function (data) {
                return CompanyParamsManager.get(companyParamsQuery).then(function (data) {
                  return data.data[0]
                })
              })
            })
          } else {
            return data.data[0]
          }
        })
      }
      return self.companyPreferences
    }

    function getQuotePrefs () {
      if (!self.quotePreferences) {
        self.quotePreferences = QuoteParamsManager.get().then(function (data) {
          if (!data.data.length) {
            return QuoteParamsManager.create(quoteDefaults).save().then(function (data) {
              return data
            })
          } else {
            return data.data[0]
          }
        })
      }
      return self.quotePreferences
    }

    function getOrderPrefs () {
      if (!self.orderPreferences) {
        self.orderPreferences = OrderParamsManager.get().then(function (data) {
          if (!data.data.length) {
            return OrderParamsManager.create(orderDefaults).save().then(function (data) {
              return data
            })
          } else {
            return data.data[0]
          }
        })
      }
      return self.orderPreferences
    }

    function getProductPrefs () {
      if (!self.productPreferences) {
        self.productPreferences = ProductParamsManager.get().then(function (data) {
          if (!data.data.length) {
            return ProductParamsManager.create(productDefaults).save().then(function (data) {
              return data
            })
          } else {
            return data.data[0]
          }
        })
      }
      return self.productPreferences
    }

    function getCreditNotePrefs () {
      if (!self.creditNotePreferences) {
        self.creditNotePreferences = CreditNoteParamsManager.get().then(function (data) {
          if (!data.data.length) {
            return CreditNoteParamsManager.create(creditNoteDefaults).save().then(function (data) {
              return data
            })
          } else {
            return data.data[0]
          }
        })
      }
      return self.creditNotePreferences
    }

    function getPrefsFor (obj) {
      switch (obj) {
        case 'general':
          return getGeneralPrefs()
        case 'invoice':
          return getInvoicePrefs()
        case 'quote':
          return getQuotePrefs()
        case 'creditnote':
          return getCreditNotePrefs()
        case 'order':
          return getOrderPrefs()
        case 'product':
          return getProductPrefs()
        case 'company':
          return getCompanyPrefs()
      }
    }

    function saveGeneralPrefs () {
      self.generalPreferences.save()
    }

    function save () {
      return self.preferences
    }

    _.extend(self, {
      getInvoicePrefs: getInvoicePrefs,
      getQuotePrefs: getQuotePrefs,
      getCreditNotePrefs: getCreditNotePrefs,
      getGeneralPrefs: getGeneralPrefs,
      getCompanyPrefs: getCompanyPrefs,
      getOrderPrefs: getOrderPrefs,
      getProductPrefs: getProductPrefs,
      getPrefsFor: getPrefsFor,
      saveGeneralPrefs: saveGeneralPrefs,
      isCompanyPrefsValid: isCompanyPrefsValid,
      save: save
    })
  }
})(window.angular, window._)
